function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29.5 10.8c-.2-.2-.6-.2-.8.1-.2.2-.9.9-1.6.9-.3 0-.6-.1-.9-.5-1-1.1-2.3-1.1-3.2-.9V6.8h3.1c.3 0 .6-.2.6-.6V1.9c0-.3-.2-.6-.6-.6H2.3c-.3 0-.6.2-.6.6v4.3c0 .3.2.6.6.6h3.1v16.4H2.3c-.3 0-.6.2-.6.6v4.3c0 .3.2.6.6.6h23.8c.3 0 .6-.2.6-.6v-4.3c0-.3-.2-.6-.6-.6H23V11.6c.4-.2 1.5-.5 2.4.5.5.5 1.1.8 1.7.8h.1c1.3 0 2.3-1.2 2.4-1.3.2-.3.1-.6-.1-.8zm-23.1.7l15.4-2.1v1.3L6.4 13v-1.5zm0-2.5l15.4-2.1v1.4L6.4 10.4V9zm0-1.2v-1h7.8l-7.8 1zM21.9 21L6.4 23.1v-1.4l15.4-2.1V21zm0 1.2v1.1H14l7.9-1.1zm0-3.7l-15.5 2v-1.4L21.8 17v1.5zm0-2.6L6.4 18v-1.4l15.4-2.1v1.4zm0-2.5L6.4 15.5v-1.4l15.4-2.2v1.5zM2.8 2.4h22.7v3.2H2.8V2.4zm22.7 25.2H2.8v-3.2h22.7v3.2z"
})));